import React, { useContext, useEffect } from "react";
import "./DarkModeToggle.css";
import { themeContext } from "../../../Context";
import { motion } from "framer-motion";
import Cookies from 'js-cookie';


export default function Toggle() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const handleClick = () => {
    theme.dispatch({ type: "toggle" });
  };

  useEffect(() => {
    if(darkMode){
        document.body.classList.add('dark');
    } else {
        document.body.classList.remove('dark');
    }

    Cookies.set('user_setting_dark_mode', darkMode, { expires: 7 });
  }, [darkMode]);

  return (
    <motion.div
      className="toggle"
      title="Toggle dark mode on and off"
      onClick={handleClick}
    >
      <i className='bx bx-sun' />
      <i className='bx bx-moon' />
      <div
        className="toggle-button"
        style={darkMode ? { left: "calc(100% - 22px)" } : { left: "2px" }}
      />
    </motion.div>

  );
}